/**
 * Получает значение CSS-переменной из :root или другого элемента.
 * @param variableName - Имя CSS-переменной (например, '--main-color').
 * @param element - Элемент, у которого нужно получить значение переменной (по умолчанию :root).
 * @returns Значение CSS-переменной в строковом формате.
 */
export function getCssVariable(
  variableName: string,
  element: HTMLElement = document.documentElement
): string {
  const computedStyles = getComputedStyle(element)
  return computedStyles.getPropertyValue(variableName).trim()
}
